import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function slugifyTerm(input: string): string {
  return input
    .toLowerCase()
    .trim()
    .replace(/&/g, 'and')
    .replace(/['’]/g, '')           // remove apostrophes
    .replace(/[^a-z0-9]+/g, '-')    // non-alphanum to hyphen
    .replace(/^-+|-+$/g, '');       // trim hyphens
}
